import SlideInFromTop from './SlideInFromTop.js';

export default SlideInFromTop;
